import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  avoidOverlap: {
    minWidth: 340,
  },
}));

export default useStyles;
